var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 7.5c0 .603-.15 1.19-.43 1.713l7.997 6.18a3.689 3.689 0 1 1-5.175 5.174l-6.18-7.998a3.622 3.622 0 0 1-4.273-.63l-.19-.19a8.154 8.154 0 0 1-1.87-2.903L2.185 6.99A2.885 2.885 0 0 1 2 5.977v-.635a.342.342 0 0 1 .603-.222l2.416 2.819a1.607 1.607 0 0 0 1.728.479l.12-.04a2.387 2.387 0 0 0 1.51-1.51l.04-.12a1.607 1.607 0 0 0-.478-1.73l-2.82-2.415A.342.342 0 0 1 5.343 2h.635c.346 0 .689.062 1.013.184l1.856.696a8.155 8.155 0 0 1 2.903 1.869l.19.19C12.62 5.62 13 6.54 13 7.5Zm-1.733 3.233-.534.534 6.242 8.077a1.689 1.689 0 1 0 2.369-2.369l-8.078-6.242Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTool);
export default __webpack_public_path__ + "static/media/ic_action_tool.bf58a49b148d725d22afae4c76d43921.svg";
export { ForwardRef as ReactComponent };